export default "__VITE_ASSET__BGRiqsLL__"